import styled from 'styled-components';

export const ViewsCountWrapper = styled.div`
  margin-left: 18px;
  display: flex;
  align-items: baseline;
  .text {
    text-decoration: none;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.limedSpruceLight};
    font-size: ${({ theme }) => theme.fontSize.sm};
    margin-left: 4px;
  }
  & > span {
    display: flex;
    align-items: center;
  }
`;
